import React from 'react';
import "./SidebarList.css";
import profilepic from "../../image/a.jpg"
import {
  FcHome,
  FcNightPortrait,
  FcTodoList,
  FcContacts,
  FcFactory,
  FcSalesPerformance
} from "react-icons/fc";
import { MdBiotech } from "react-icons/md";
import { MdCastForEducation } from "react-icons/md";
import { Link } from "react-scroll";
const SidebarList = ({ expandSidebar }) => {
  return (
    <React.Fragment>

      {expandSidebar ? (
        <div className='navbar-item'>
          <div className='sidebar-profile-pic'>
            <img src={profilepic} alt="profile pictre" />
          </div>
          <ul>
            <li className='nav-item'>
              <Link to="home"
                spy={true}
                smooth={true}
                duration={100}
                offst={-100}>
                <FcHome size={25} /> Home
              </Link>
            </li>
            <li className='nav-item'>
              <Link to="about"
                spy={true}
                smooth={true}
                duration={100}
                offst={-100}>
                <FcNightPortrait size={25} /> About
              </Link>
            </li>
            <li className='nav-item'>
              <Link to="workexperience"
                spy={true}
                smooth={true}
                duration={100}
                offst={-100}><FcFactory size={25} /> Work Experience
              </Link></li>
            <li className='nav-item'>
              <Link to="tech-stack"
                spy={true}
                smooth={true}
                duration={100}
                offst={-100}>
                <MdBiotech size={25} color="orange" />Tech Stack
              </Link></li>
            <li className='nav-item'>
              <Link to="education"
                spy={true}
                smooth={true}
                duration={100}
                offst={-100}><MdCastForEducation size={25} />Education
              </Link></li>
            <li className='nav-item'>
              <Link to="projects"
                spy={true}
                smooth={true}
                duration={100}
                offst={-100}><FcTodoList size={25} />Projects
              </Link></li>
            <li className='nav-item'>
              <Link to="testimonial"
                spy={true}
                smooth={true}
                duration={100}
                offst={-100}><FcSalesPerformance size={25} /> Testimonial
              </Link></li>
            <li className='nav-item'>
              <Link to="contactsection"
                spy={true}
                smooth={true}
                duration={100}
                offst={-100}><FcContacts size={25} /> Contact
              </Link></li>


          </ul>
        </div>) : (
        <div className="navbar-items-only-ions">

<ul>
            <li className='nav-item'>
              <Link to="home"
                spy={true}
                smooth={true}
                duration={100}
                offst={-100}>
                <FcHome size={25} />
              </Link>
            </li>
            <li className='nav-item'>
              <Link to="about"
                spy={true}
                smooth={true}
                duration={100}
                offst={-100}>
                <FcNightPortrait size={25} /> 
              </Link>
            </li>
            <li className='nav-item'>
              <Link to="workexperience"
                spy={true}
                smooth={true}
                duration={100}
                offst={-100}><FcFactory size={25} /> 
              </Link></li>
            <li className='nav-item'>
              <Link to="tech-stack"
                spy={true}
                smooth={true}
                duration={100}
                offst={-100}>
                <MdBiotech size={25} color="orange" />
              </Link></li>
            <li className='nav-item' style={{color:"white"}} >
              <Link to="education" 
                spy={true}
                smooth={true}
                duration={100}
                offst={-100}><MdCastForEducation size={25} />
              </Link></li>
            <li className='nav-item'>
              <Link to="projects"
                spy={true}
                smooth={true}
                duration={100}
                offst={-100}><FcTodoList size={25} />
              </Link></li>
            <li className='nav-item'>
              <Link to="testimonial"
                spy={true}
                smooth={true}
                duration={100}
                offst={-100}><FcSalesPerformance size={25} /> 
              </Link></li>
            <li className='nav-item'>
              <Link to="contactsection"
                spy={true}
                smooth={true}
                duration={100}
                offst={-100}><FcContacts size={25} /> 
              </Link></li>


          </ul>

        </div>
      )}



    </React.Fragment>
  );
};
export default SidebarList;